/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ theme, products, onAddToCart, onOpenProduct }) => {
  return (
    <section id="all-products" className="t3-products" dir="rtl">
      <div className="t3-container">
        <div className="t3-section-head">
          <div>
            <h2>تسوق حسب المنتجات</h2>
            <p>عرض كل المنتجات المتوفرة في المتجر</p>
          </div>
        </div>

        {products.length > 0 ? (
          <div className="t3-product-grid">
            {products.map((product, idx) => (
              <ProductCard
                key={product.id || idx}
                compact
                product={product}
                theme={theme}
                onAddToCart={onAddToCart}
                onOpenProduct={onOpenProduct}
              />
            ))}
          </div>
        ) : (
          <div className="t3-empty">لا توجد منتجات في هذا القسم حالياً</div>
        )}
      </div>
    </section>
  );
};

export default ProductGrid;
